import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './campaign_action.less'
import { getI18n } from 'client/i18n'
import { Link } from 'react-router'
import { glimpseRoute } from 'lib/route_utils'
import FixedGradient from 'components/common/fixed_gradient'
import ChipInButton from 'components/pages/campaign/chip_in_button'
import StandardDialog from 'components/common/standard_dialog'

const i18n = getI18n([
  'components/campaign_action',
  'components/pages/campaign',
])

class CampaignAction extends React.Component {
  static propTypes = {
    isOwner: PropTypes.bool,
    showFixedGradient: PropTypes.bool,
    showManageButton: PropTypes.bool,
    preview: PropTypes.bool,
    campaignTitle: PropTypes.string,
    campaignId: PropTypes.string,
  }

  state = {
    showPreviewDialog: false,
  }

  handleChipInClick = event => {
    if (this.props.preview) {
      event.preventDefault()
      this.setState({ showPreviewDialog: true })
    }
  }

  handlePreviewDialogClose = () => {
    this.setState({ showPreviewDialog: false })
  }

  render() {
    return (
      <div styleName="container">
        {this.state.showPreviewDialog && (
          <StandardDialog
            size="small"
            title={i18n('preview_dialog_title')}
            subtitle={i18n('preview_dialog_description')}
            closeButtonTitle={i18n('preview_dialog_button')}
            onClose={this.handlePreviewDialogClose}
          />
        )}
        {this.props.showManageButton && (
          <div styleName="manage-button-container">
            <Link
              to={glimpseRoute('edit', 'manage')}
              styleName="manage-button"
              className="vx_btn vx_btn-block"
              data-pa-click="manage"
              data-nemo="manage"
            >
              {i18n('manage')}
            </Link>
          </div>
        )}
        <FixedGradient enabled={this.props.showFixedGradient}>
          <div styleName="grid-container fixed-gradient-grid">
            <div styleName="grid-row">
              <div
                styleName="left-part fixed-campaign-title"
                className="hidden-xs"
              >
                {this.props.campaignTitle}
              </div>
              <div styleName="right-part">
                <div styleName="chip-in-button-container">
                  <ChipInButton
                    onClick={this.handleChipInClick}
                    secondary={true}
                    reversed={true}
                    campaignId={this.props.campaignId}
                  />
                </div>
              </div>
            </div>
          </div>
        </FixedGradient>
        <div styleName="chip-in-button-container">
          <ChipInButton
            campaignId={this.props.campaignId}
            onClick={this.handleChipInClick}
            secondary={this.props.showManageButton}
          />
        </div>
      </div>
    )
  }
}

export default cssModules(CampaignAction, styles, { allowMultiple: true })
